import React from 'react';

function TopScrolleable(WrappedComponent) {
    // ...and returns another component...
    return class extends React.Component {

        componentWillMount(){
            window.scrollTo(0, 0);
        }

        render() {
            // ... and renders the wrapped component with the fresh data!
            // Notice that we pass through any additional props
            return (<WrappedComponent {...this.props} />);
        }
    };
}

export default TopScrolleable;


/** WEBPACK FOOTER **
 ** ./src/components/TopScrolleable.js
 **/